import script from "./Simulations.vue?vue&type=script&setup=true&lang=js"
export * from "./Simulations.vue?vue&type=script&setup=true&lang=js"

import "./Simulations.vue?vue&type=style&index=0&id=a56a8d48&lang=scss&scoped=true"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a56a8d48"]])

export default __exports__